import { HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { DispatchService } from 'src/app/services/dispatch.service';
import { LoggerService } from 'src/app/services/logger.service';
import { ManageVansService } from 'src/app/services/manage-vans.service';
import { ToastService } from 'src/app/services/toast.service';


export interface DialogData {
  preferredDriversList: any;
  driverSummaryList: any;
}

@Component({
  standalone: false,
  selector: 'app-preferred-drivers-dialog',
  templateUrl: './preferred-drivers-dialog.component.html',
  styleUrls: ['./preferred-drivers-dialog.component.scss']
})
export class PreferredDriversDialogComponent implements OnInit {

  driverSummaryList: any;
  preferredDriversList: any;
  layeron=[];

  constructor(
    public dialogRef: MatDialogRef<PreferredDriversDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private manageVansService: ManageVansService,
    private logger: LoggerService,
    private toastService: ToastService,
    private dispatchService: DispatchService
  ) { }

  ngOnInit(): void {
    this.preferredDriversList = this.data.preferredDriversList;
    this.driverSummaryList = this.data.driverSummaryList;
  }

  saveDriverPreferences(){
    this.logger.info('saveDriverPreferences called');
    this.manageVansService.savePrefDriverList(this.preferredDriversList)
    .subscribe({
      next: (resp: HttpResponse<any>) => {
        this.logger.debug(`PUT preferred drivers response:`, resp, 'http');
        if(resp.status === 201){
          setTimeout(() => {
            this.dispatchService.runWorkerThread();
            this.dialogRef.close();
          }, 100);
          this.toastService.show(`Preferred drivers list saved`, { classname: 'bg-success text-light', delay: 4000 });
        }else{
          this.toastService.show(`Error saving preferred drivers list!`, { classname: 'bg-danger text-light', delay: 4000 });
        }
      },
      error: (err) => {
        this.logger.error('Failed to save preferred drivers list:', err);
        this.toastService.show(`Error saving preferred drivers list!`, { classname: 'bg-danger text-light', delay: 4000 });
      }
    });
  }

  updateDriverPreferences(e: MatSlideToggleChange, driverId: string){
    e.checked
      ? this.preferredDriversList.push(driverId.toUpperCase())
      : this.preferredDriversList.splice(this.preferredDriversList.indexOf(driverId.toUpperCase()), 1);
  }

}
